<head>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.css">
    <!-- </link> -->
</head>
<body>
    <span id="clickableAwesomeFont" (click)="jobLogPopup()"><i class="fas fa-file-excel"></i></span>
</body> 
